import { useParams } from "react-router";
import { useMunicipalitySchoolsAttendance } from "hooks/attendance";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import styles from "app/dashboard/RegionSchoolsAttendancePage/RegionSchoolsAttendancePage.module.styl";
import React from "react";
import MunicipalitySchoolsAttendanceView from "components/municipalitySummary/MunicipalitySchoolsAttendanceView/MunicipalitySchoolsAttendanceView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";
import { Helmet } from "react-helmet-async";

export default function MunicipalitySchoolsAttendancePage() {
    const { municipalityId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useMunicipalitySchoolsAttendance(municipalityId);

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Посещаемость: ${data.municipalityName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Посещаемость: ${data.municipalityName}`}
                    />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/municipality-summary/${municipalityId}`}
                        text={"Назад"}
                        name={"back_link"}
                    />
                )}

                <Heading size={"h1"} className={styles.heading} name="municipality-school-attendance-header">
                    Посещаемость: {data.municipalityName}
                </Heading>
                <MunicipalitySchoolsAttendanceView
                    municipalityId={municipalityId}
                    schoolsAttendance={data.schoolsAttendance}
                />
            </>
        );
    }
}
